import styled from 'styled-components';

import { breakpoints, theme } from '@notino/react-styleguide';

export const LoginWrapper = styled.div`
  text-align: center;
  margin-top: 1rem;
  color: ${theme.color.text.secondary};
`;

export const LoginLink = styled.a`
  cursor: pointer;
  text-decoration: underline;
  color: ${theme.color.text.secondary};
  margin-left: 0.5rem;

  &:hover {
    text-decoration: none;
  }

  color: ${theme.color.text.primary};
  font-weight: 500;
`;

export const StepProgressCircle = styled.div<{
  isFulfilled: boolean;
}>`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 1.125rem;
  height: 1.125rem;
  background: ${(props) =>
    props.isFulfilled
      ? theme.color.background.inverse
      : theme.color.background.tertiary};
  border-radius: 50%;
  margin-right: 1.125rem;
  width: 1.25rem;
  height: 1.25rem;
`;

export const StepWrapper = styled.span`
  display: flex;
  width: 100%;
  margin: 1rem auto;
  text-align: left;

  &:first-child {
    margin: 0.75rem 0 0.5rem;
  }
  &:last-child {
    margin: 0;
  }
  margin: 0 0 0.5rem;
`;

export const FooterContent = styled.div`
  display: flex;
  flex-direction: column;
  padding: 0 1.25rem;
  @media (min-width: ${breakpoints.md}) {
    padding: 0 2rem;
    align-items: flex-start;
  }
`;
